import Api from "../api.js";
export default false
  ? {
      message: "You are Offline. Please! turn on the internet",
    }
  : {
      adminSigninApi: (finaldata) => {
        return Api.post("/auth/login", finaldata);
      },
    };
